import "./style.less";

export default function TitleBar() {
    return {
        restrict: "E",
        scope: {
            activity: "<",
            location: "<",
            prefix: "@",
            suffix: "@",
        },
        template: require("./template.html"),

        controller: function ($scope) {
            let title = "";

            if ($scope.activity && $scope.activity.hasOwnProperty("Name")) {
                title = $scope.activity.Name;
            }

            if ($scope.location && $scope.location.hasOwnProperty("Name")) {
                title += " - " + $scope.location.Name;
            }

            $scope.title = title;
        },
    };
}
